module.exports = __webpack_public_path__ + "static/img/peo03@2x.f64f8e22.png";